import {UmpireComponent} from '../umpire-component';
import {UmpireComponentType} from '../umpire-component-type';
import {UmpireProductTypeEnum} from '../umpire-product-type';

export type globalPageElementType = 'global_page_element';

export enum UmpireGlobalPageElementSlugEnum {
  BRANDING = 'branding',
  HEADER_FOOTER = 'header_footer',
  ELEMENTS_BELOW_CONTENT = 'elements_below_content',
}

export interface UmpireGlobalPageElement {
  id: string;
  type: globalPageElementType;
  name: string;
  components: UmpireComponent<UmpireComponentType>[];
  updated_at: string;
  created_at: string;
  slug: UmpireGlobalPageElementSlugEnum;
  product: UmpireProductTypeEnum;
}
